import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import logo_bottom from 'assets/imgs/pmagua.png';
import Padoru from 'util/padoru';
import { saveUriPadoru } from 'util/padoru-api';
import Capa from './Capa';
import squareBase from 'assets/imgs/base.svg';
import type { PadoruUri, PadoruVersion, PartUri } from 'interfaces/padoru';

interface Props {
  padoru: Padoru;
  padoruName: string;
  isMobile: boolean;
  v?: PadoruVersion;
}

export function PreviewStyled(props: Props) {
  const { padoru, padoruName, isMobile, v } = props;
  const [parts, setParts] = useState<PartUri[]>([]);

  useEffect(() => {
    const parts1: PartUri[] = Padoru.toPadoruUri(padoru, v).parts;
    setParts(parts1);
  }, [padoru]);

  useEffect(() => {
    const uriPadoru: PadoruUri = {
      id: padoru.id,
      name: padoruName,
      parts: parts,
    };
    saveUriPadoru(uriPadoru);
  }, [parts]);

  return (
    <Box sx={{ position: 'relative' }} id="preview_wrapper">
      <CardMedia
        id="basse_white"
        title="basse"
        image={squareBase}
        width="100%"
        height="auto"
        component="img"
      />

      <Box>
        {parts.map((part, key) => (
          <Capa key={key} partId={part.uuid} svgUri={part.uri} isMobile={isMobile} />
        ))}

        <Box
          id="marca_agua"
          component="img"
          src={logo_bottom}
          position={'absolute'}
          bottom={0}
          right={0}
          height={0.085}
          width={0.56}
        />
      </Box>
    </Box>
  );
}
